import { render, staticRenderFns } from "./AboutAccount.vue?vue&type=template&id=564eaa56&"
import script from "./AboutAccount.vue?vue&type=script&lang=js&"
export * from "./AboutAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports